export default __webpack_public_path__ + "static/media/gmail.cfbaba11.png";